import React from 'react'
import { css } from 'aphrodite'

import style from '../style'

export const Menu = props => (
  <div className={(css(style.menu.menu), props.className)}>
    {props.children}
  </div>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/partials/Editor/partials/Menu.js